<script setup lang="ts">
import type { UmbracoFormField } from 'types/blocks';

const FormFieldCheckBox = resolveComponent('LazyPartialsFormFormFieldCheckBox');
const FormFieldDropDownList = resolveComponent('LazyPartialsFormFormFieldDropDownList');
const FormFieldEmail = resolveComponent('LazyPartialsFormFormFieldEmail');
const FormFieldNumber = resolveComponent('LazyPartialsFormFormFieldNumber');
const FormFieldPhone = resolveComponent('LazyPartialsFormFormFieldPhone');
const FormFieldRadioButtonList = resolveComponent('LazyPartialsFormFormFieldRadioButtonList');
const FormFieldText = resolveComponent('LazyPartialsFormFormFieldText');
const FormFieldTextField = resolveComponent('LazyPartialsFormFormFieldTextField');
const FormFieldTextArea = resolveComponent('LazyPartialsFormFormFieldTextArea');

const props = defineProps<{
  field: UmbracoFormField;
}>();

const fieldTemplate = computed(() => {
  let field = null;

  if (!props.field.type) {
    return field;
  }

  const type = props.field.type;
  const fieldType = props.field.settings.fieldType;

  if (type === 'dropdownlist' && props.field.preValues.length > 0) {
    field = FormFieldDropDownList;
  }

  if (type === 'checkbox' || type === 'dataconsent') {
    field = FormFieldCheckBox;
  }

  if (type === 'textfield' && fieldType === 'number') {
    field = FormFieldNumber;
  }

  if (type === 'textfield' && (fieldType === 'text' || fieldType === '')) {
    field = FormFieldTextField;
  }

  if (type === 'textfield' && fieldType === 'tel') {
    field = FormFieldPhone;
  }

  if (type === 'textfield' && fieldType === 'email') {
    field = FormFieldEmail;
  }

  if (type === 'textarea') {
    field = FormFieldTextArea;
  }

  if (type === 'radiobuttonlist') {
    field = FormFieldRadioButtonList;
  }

  if (type === 'text') {
    field = FormFieldText;
  }

  if (field === null) {
    const loggingService = useLoggingService();
    loggingService.error('Form field type not recognised!');
  }

  return field;
});
</script>

<template>
  <Component
    :is="fieldTemplate"
    v-if="fieldTemplate"
    :field="props.field"
  />
</template>
